<template>
  <div class="image-box image-box-filter shadow-b">
    <m-img
        :src="image"
        alt="Unsplashed Random"
        class="img-cov"

    />
    <div class="centered">

      <slot name="p-1"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "S12",
  props: {
    image: {
      default: "",
    },
  },
};
</script>

<style scoped>
/* container-n holding the image and the text */
.image-box {
  position: relative;
  margin: auto;
  overflow: hidden;
  width: 100%;
  text-align: center;
  color: white;
  border-radius: 10px;

}

.image-box:after {
  content: '';
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 1;
}

.image-box-filter:after {
  background-image: linear-gradient(180deg, transparent 50%, #ffffff);
}

.image-box img {
  max-width: 100%;
  transition: all 0.3s;
  display: block;
  width: 100%;
  height: 400px;
  transform: scale(1);
  object-fit: cover;
}

.image-box:hover img {
  transform: scale(1.1);
  filter: blur(0.2rem);
}


.centered {
  position: absolute;
  top: 80%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s;
  z-index: 2;
}

.image-box:hover .centered {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.3s;

}

.shadow-b:hover {
  box-shadow: 5px 5px 15px #b8b8b8;
}
</style>